import React from 'react';
import Fade from '@mui/material/Fade';
import MuiModal from '@mui/material/Modal';

import {
  StyledBody,
  StyledContainer,
  StyledContent,
  StyledFooter,
  StyledHeader,
  StyledIconButton,
} from './styles';
import type { ModalProps } from './types';

export default function Modal({
  children,
  close,
  closeButtonCss,
  containerCss,
  contentCss,
  footer,
  header,
  headerCss,
  showClose = true,
  ...props
}: ModalProps) {
  const handleClose = () => {
    close();
  };

  return (
    <MuiModal closeAfterTransition onClose={handleClose} {...props}>
      <section>
        <Fade in={props.open}>
          <StyledContainer style={containerCss}>
            <StyledBody>
              {header && (
                <StyledHeader style={headerCss}>{header}</StyledHeader>
              )}

              {header && showClose && (
                <StyledIconButton
                  aria-hidden={!props.open}
                  aria-label="Close Modal"
                  icon="close"
                  onClick={handleClose}
                  style={closeButtonCss}
                />
              )}

              <StyledContent style={contentCss}>
                {!header && showClose && (
                  <StyledIconButton
                    icon="close"
                    onClick={handleClose}
                    style={closeButtonCss}
                  />
                )}

                {children}
              </StyledContent>

              {footer && <StyledFooter>{footer}</StyledFooter>}
            </StyledBody>
          </StyledContainer>
        </Fade>
      </section>
    </MuiModal>
  );
}
